import { SelectedDeliveryAddress } from './types';

export const getAddressLabel = ({ address }: SelectedDeliveryAddress) =>
  `${address.addressLine1}, ${address.city}, ${address.state} ${address.zip}, ${address.country}`;
